import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';

import {
  fetchTemplatesLibraryRequest,
  fetchTemplatesLibrarySuccess,
  fetchTemplatesLibraryFailure,
} from '../slices/templatesLibrarySlice.ts'

import type { TemplatesLibraryResponse } from '../../components/templatesLibrary/types.ts';
import { ENDPOINTS, PROMOFLOW_BASE_API_URL } from '../../api/endPoints';

function* fetchTemplatesLibrarySaga(
  action: PayloadAction<{ restaurantId: string }>
): Generator<any, void, any> {
  try {
    const { restaurantId } = action.payload;

    // Fetch PromoFlow templates
    const response = yield call(
      axios.get,
      ENDPOINTS.promoTemplates,
      {
        headers: {
          'restaurant-id': restaurantId,
          "Access-Control-Allow-Origin": "*"
        },
        params: {
          serviceType: 'promoflow',
        },
      }
    );

    const promoFlowData: TemplatesLibraryResponse = response.data;

    // Extract templates from API response
    const templates =
      promoFlowData.data?.flatMap(
        item => item.metadata?.templates || []
      ) || [];

    yield put(
      fetchTemplatesLibrarySuccess(templates)
    );
  } catch (error: any) {
    yield put(
      fetchTemplatesLibraryFailure(
        error.response?.data?.message ||
          error.message ||
          'Failed to fetch PromoFlow templates'
      )
    );
  }
}

export function* templatesLibrarySaga() {
  yield takeLatest(
    fetchTemplatesLibraryRequest.type,
    fetchTemplatesLibrarySaga
  );
}